export default id => (dispatch, getState) => {
  dispatch({ type: 'DELETE_PORTFOLIO', id, pending: true });

  const state = getState();

  const body = {
    sedol: null,
    isin: null,
    cusip: null,
    clientEmail: state.clientEmail,
    isDeleted: true,
  };

  fetch(`${process.env.REACT_APP_DPD_URL}/api/portfolio/${id}/`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: state.token &&
        `Token ${state.token}`,
    },
  })
    .then(d => d.json())
    .then(data => {
      dispatch({ type: 'DELETE_PORTFOLIO', id });
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: 'DELETE_PORTFOLIO', id, pending: false });
    });
};



// WEBPACK FOOTER //
// ./src/actions/delete-portfolio.js